/** How the app shell frames a route, from its primary path without the leading slash (for example `showcase/x`). */
export interface AppRouteLayout {
  /** The embedded viewer: only the canvas, no menu and no padding. */
  readonly sceneOnly: boolean;
  /** Full-bleed pages without the menu: the stand, the showcases and the help page. */
  readonly fullBleed: boolean;
  /** Full-bleed pages that scroll as a document, such as the showcase index and the help page. */
  readonly scrollable: boolean;
}

/** The help page route path, shared by the router and the app shell. */
export const VIEWER_HELP_PATH: string = 'help';

const DOCUMENT_PATHS: ReadonlySet<string> = new Set<string>(['showcase', VIEWER_HELP_PATH]);

export function appRouteLayout(path: string): AppRouteLayout {
  const scrollable: boolean = DOCUMENT_PATHS.has(path);
  return {
    sceneOnly: path === 'viewer/embed',
    fullBleed: scrollable || path === 'viewer' || path === 'viewer/embed' || path.startsWith('showcase/'),
    scrollable,
  };
}
